<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Weekly Reward Categories'
                    : 'Deleted Weekly Reward Categories'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/weekly-rewards/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="category"
                    solo
                    rounded
                    v-model="filter.category_id"
                    :items="categories"
                    item-text="description"
                    item-value="id"
                    clearable
                    @click:clear="(filter.category_id = null), (page = 1)"
                    label="Category"
                    @input="getData"
                    prepend-inner-icon="mdi-tag"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Category</th>
                      <th class="text-left">Total Rewards</th>
                      <th class="text-left">Active Rewards</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="weeklyRewards.length != 0">
                    <tr
                      v-for="(category, i) in weeklyRewards"
                      :key="`category_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': weeklyRewards.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        {{ category.category ? category.category.description : 'No Category' }}
                      </td>
                      <td>
                        <v-chip color="blue" text-color="white" small>
                          <v-icon left small>mdi-gift</v-icon>
                          {{ category.total_rewards }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip color="teal" text-color="white" small>
                          <v-icon left small>mdi-check-circle</v-icon>
                          {{ category.active_rewards }}
                        </v-chip>
                      </td>
                      <!-- <td>
                        <v-chip color="red" text-color="white" small>
                          <v-icon left small>mdi-close-circle</v-icon>
                          {{ category.inactive_rewards }}
                        </v-chip>
                      </td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="primary"
                                class="mr-2"
                                :to="`/weekly-rewards/category/${encryptIt(category.category_id)}`"
                              >
                                <v-icon dark> mdi-eye </v-icon>
                              </v-btn>
                            </template>
                            <span>View Weekly Rewards for this Category</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="success"
                                :to="`/weekly-rewards/category/${encryptIt(category.category_id)}/edit`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Weekly Rewards for this Category</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_rewards" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Weekly Rewards deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_rewards = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_rewards" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Weekly Rewards restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_rewards = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "weeklyRewardsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        category_id: "",
      },
      weeklyRewards: [],
      categories: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Company: "company_name",
        Coin: "coin",
        "Expiry Days": "expairy_days",
      },
      isLoading: false,
      isExcelloading: false,
      delete_rewards: false,
      restore_rewards: false,
      is_deleted_rewards: false,
      is_restored_rewards: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getCategories();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.company_id = this.filter.company_id
        ? this.filter.company_id
        : "";
      this.filter.category_id = this.filter.category_id
        ? this.filter.category_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&company_id=" +
        this.filter.company_id +
        "&category_id=" +
        this.filter.category_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`weekly_rewards?${query}`)
        .then((response) => {
          this.weeklyRewards = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async getCategories() {
      try {
        const response = await axios.get("/masters?context=reward_category");
        this.categories = response.data.reward_category;
        console.log("reward_category", this.categories);
      } catch (e) {
        console.log(e);
      }
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`store_rewards_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_rewards = true;
      await axios
        .post(`/weekly_rewards/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_rewards = false;
          this.is_deleted_rewards = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_rewards = true;
      await axios
        .post(`/weekly_rewards/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_rewards = false;
          this.is_restored_rewards = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
